<template>
  <v-card
    class="px-5 py-3 transition"
    style="height:330px;position:relative;"
    :to="{ name: 'Product', params: { product: product.id } }"
  >
    <div class="product-floating-items right">
      <v-chip
        v-if="!product.verified"
        outlined
        small
        class=" mb-3"
        color="warning"
        >Unverified</v-chip
      >
      <v-chip
        v-if="product.status"
        outlined
        class="mb-3"
        small
        color="accent"
        >{{ lo.capitalize(lo.lowerCase(product.status)) }}</v-chip
      >
    </div>
    <div class="product-floating-items left">
      <v-icon class="mb-3" v-if="product.gender"
        >mdi-gender-{{
          { men: "male", women: "female", unisex: "male-female" }[
            product.gender
          ]
        }}</v-icon
      >
    </div>
    <v-card-title
      class="pt-10 d-flex pb-2 flex-row justify-space-between flex-flow-column"
    >
      <!-- <div>
        <div class="text-h5 mb-2">
          {{ product.name }}
        </div>
        <div>
          <span class="subtitle-1">{{
            moment(product.created_at).format("YYYY-MM-DD")
          }}</span>
          <v-chip
            v-if="!product.verified"
            outlined
            small
            class="ml-3"
            color="warning"
            >Unverified</v-chip
          >
        </div>
        <v-chip
          v-if="product.status && product.verified"
          outlined
          small
          color="accent"
          >{{ lo.capitalize(lo.lowerCase(product.status)) }}</v-chip
        >
      </div> -->
    </v-card-title>
    <v-card-text
      class="subtitle-1  d-flex flex-column align-center justify-space"
    >
      <!-- {{ limit(product.description) }} -->

      <div>
        <v-img
          v-if="product['image_url']"
          :src="product['image_url']"
          contain
          height="120"
          width="120"
          class="rounded-md ma-2"
        ></v-img>
        <v-img
          v-else
          src="@/assets/logo_black_no_text.png"
          contain
          height="120"
          width="120"
          class="pa-2"
        ></v-img>
      </div>
      <div class="font-weight-light text-center subtitle-1">
        <span v-if="product.product_group">{{ product.product_group }}</span>
        <span v-else class="grey--text">-</span>
      </div>
      <div class="font-weight-bold text-center">
        <span class="text-clipper" v-if="product.name">{{ product.name }}</span>
        <span v-else class="grey--text">"Name not available"</span>
      </div>
      <div class="py-2">
        <v-chip
          class="mx-1"
          v-if="product.product_type"
          outlined
          small
          color="teal"
          >{{ product.product_type }}</v-chip
        >
        <v-chip class="mx-1" v-if="product.year" outlined small color="grey">{{
          product.year
        }}</v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment"
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  methods: {
    moment,
    limit(str) {
      const limit = 150
      if (str) return str.length > limit ? str.slice(0, limit) + "..." : str
      return ""
    }
  }
}
</script>

<style lang="scss" scoped>
.transition {
  transition: 0.3s all;
}
.flex-center {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.product-floating-items {
  display: flex;
  flex-direction: column;
  &.right {
    align-items: flex-end;
    right: 25px;
    left: auto;
  }
  i {
    color: lightgrey !important;
  }
  position: absolute;
  top: 25px;
  left: 25px;
}
.text-clipper {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
